import qs from 'qs';
import useAPI from '../core/hooks/useApi';

export const useGetConfirmationsByOptInId = optInId =>
  useAPI(`/api/confirmations?${qs.stringify({ optInId })}`);
